var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, useEffect, useRef } from "react";
export function TruncateLines(_a) {
    var _b = _a.lines, lines = _b === void 0 ? 1 : _b, _c = _a.ellipsis, ellipsis = _c === void 0 ? "…" : _c, children = _a.children, rest = __rest(_a, ["lines", "ellipsis", "children"]);
    var rootSpanRef = useRef(null);
    var ellipsisSpanRef = useRef(null);
    var text = onlyText(children);
    useEffect(function () {
        var rootSpan = rootSpanRef.current;
        var ellipsisSpan = ellipsisSpanRef.current;
        var textNode = rootSpan.firstChild;
        fixWebKitClientRects(rootSpan);
        ellipsisSpan.style.display = "none";
        textNode.nodeValue = text;
        if (rootSpan.getClientRects().length <= lines)
            return;
        ellipsisSpan.style.display = "inline-block";
        var newLength = lastIndexWhere(0, text.length, function (length) {
            textNode.nodeValue = text.slice(0, length);
            return length === 0 || rootSpan.getClientRects().length <= lines;
        });
        textNode.nodeValue = text.slice(0, newLength);
    }, [lines, ellipsis, text]);
    return (_jsxs("span", __assign({ ref: rootSpanRef }, rest, { children: [text, _jsx("span", __assign({ ref: ellipsisSpanRef, style: { display: "none" } }, { children: ellipsis }))] })));
}
function lastIndexWhere(start, end, predicate) {
    // invariant: predicate(start) === true && predicate(end + 1) === false
    while (start < end) {
        var mid = start + ((end - start) >> 1);
        // start <= mid < end
        if (predicate(mid + 1)) {
            start = mid + 1;
        }
        else {
            end = mid;
        }
    }
    return start;
}
function onlyText(children) {
    var result = "";
    Children.forEach(children, function (child) {
        if (typeof child === "number" || typeof child === "string") {
            result += child.toString();
        }
        else {
            throw new TypeError("Unexpected child type");
        }
    });
    return result;
}
function fixWebKitClientRects(element) {
    var s = element.style;
    var styleValue = s.getPropertyValue("outline-style");
    var stylePriority = s.getPropertyPriority("outline-style");
    var widthValue = s.getPropertyValue("outline-width");
    var widthPriority = s.getPropertyPriority("outline-width");
    s.setProperty("outline-style", "solid", "important");
    s.setProperty("outline-width", "1px", "important");
    element.getClientRects();
    s.setProperty("outline-style", styleValue, stylePriority);
    s.setProperty("outline-width", widthValue, widthPriority);
}
